import React from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Background from '../Layout/Background';

const Maintenance: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="theme-light">
        <div className="wrapper">
          <main>
            <div>
              <Background />

              <div className="topbar topbar--navigation">
                <div className="topbar">
                  <div className="topbar__wrapper">
                    <div className="topbar__left">
                      <span className="topbar__logo" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="container__wrap" style={{ display: 'flex', alignItems: 'center' }}>
                <Container
                  className="dashboard"
                  style={{ alignItems: 'center', textAlign: 'center' }}
                >
                  <div className="title-content" style={{ alignItems: 'center' }}>
                    <div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          width="166.388"
                          height="95.695"
                          viewBox="0 0 166.388 95.695"
                        >
                          <defs>
                            <clipPath id="clip-path">
                              <rect
                                id="Rectangle_949"
                                data-name="Rectangle 949"
                                width="166.388"
                                height="95.695"
                                transform="translate(0 0)"
                                fill="none"
                              />
                            </clipPath>
                          </defs>
                          <g id="Group_1392" data-name="Group 1392" transform="translate(0 0)">
                            <g id="Group_1391" data-name="Group 1391" clipPath="url(#clip-path)">
                              <path
                                id="Path_1831"
                                data-name="Path 1831"
                                d="M160.985,33.275H107.406a5.418,5.418,0,0,1-5.4-5.4v-.585a5.419,5.419,0,0,1,5.4-5.4h53.579a5.419,5.419,0,0,1,5.4,5.4v.585a5.418,5.418,0,0,1-5.4,5.4"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1832"
                                data-name="Path 1832"
                                d="M48.843,42.281H11.467a4.607,4.607,0,0,1-4.594-4.594v-2.2a4.608,4.608,0,0,1,4.594-4.6H48.843a4.609,4.609,0,0,1,4.6,4.6v2.2a4.608,4.608,0,0,1-4.6,4.594"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1833"
                                data-name="Path 1833"
                                d="M131.2,65.034H77.62a5.418,5.418,0,0,1-5.4-5.4v-.585a5.419,5.419,0,0,1,5.4-5.4H131.2a5.419,5.419,0,0,1,5.4,5.4v.585a5.418,5.418,0,0,1-5.4,5.4"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1834"
                                data-name="Path 1834"
                                d="M83.7,87.555H5.7a5.7,5.7,0,1,1,0-11.392h78a5.7,5.7,0,0,1,0,11.392"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1835"
                                data-name="Path 1835"
                                d="M149.748,65.034h-.972a5.225,5.225,0,0,1-5.21-5.21v-.972a5.226,5.226,0,0,1,5.21-5.21h.972a5.226,5.226,0,0,1,5.21,5.21v.972a5.225,5.225,0,0,1-5.21,5.21"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1836"
                                data-name="Path 1836"
                                d="M6.719,65.034H5.747a5.225,5.225,0,0,1-5.21-5.21v-.972a5.226,5.226,0,0,1,5.21-5.21h.972a5.226,5.226,0,0,1,5.21,5.21v.972a5.225,5.225,0,0,1-5.21,5.21"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1837"
                                data-name="Path 1837"
                                d="M116.039,94.36c-5.265,0-10.533-.1-15.795.025a7.769,7.769,0,0,1-6.9-11.678q5.663-9.743,11.27-19.516,2.349-4.07,4.7-8.137a7.7,7.7,0,0,1,13.356-.161q8.16,13.936,16.145,27.976a7.667,7.667,0,0,1-6.762,11.489c-5.338.012-10.677,0-16.016,0"
                                fill="#fff"
                              />
                              <path
                                id="Path_1838"
                                data-name="Path 1838"
                                d="M116.04,94.36c-5.266,0-10.533-.1-15.8.025a7.768,7.768,0,0,1-6.9-11.678c3.775-6.5,7.514-13.01,11.27-19.516q2.348-4.068,4.7-8.137a7.7,7.7,0,0,1,13.357-.161q8.159,13.936,16.145,27.975a7.667,7.667,0,0,1-6.762,11.489c-5.339.013-10.677,0-16.016,0m.015-2.507q7.9,0,15.794,0a5.087,5.087,0,0,0,4.717-2.585,5.146,5.146,0,0,0-.121-5.5q-5.655-9.747-11.271-19.515c-1.616-2.8-3.152-5.644-4.893-8.36a5.121,5.121,0,0,0-8.437-.068c-.477.68-.856,1.425-1.273,2.146q-7.515,12.995-15.008,26a5.5,5.5,0,0,0-.7,2.208,5.137,5.137,0,0,0,5.328,5.667c5.289.014,10.578,0,15.867,0"
                                fill="#b0bccb"
                              />
                              <path
                                id="Path_1839"
                                data-name="Path 1839"
                                d="M116.055,90.374c-3.853,0-7.708-.071-11.559.018a5.776,5.776,0,0,1-5.047-8.686c2.763-4.831,5.5-9.678,8.247-14.517l3.439-6.053a5.593,5.593,0,0,1,9.774-.12q5.972,10.368,11.814,20.81a5.7,5.7,0,0,1-4.947,8.546c-3.907.009-7.814,0-11.721,0"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1840"
                                data-name="Path 1840"
                                d="M118.074,71.741q0,3.27,0,6.539c0,.956-.117,1.071-1.045,1.076-.71,0-1.421-.019-2.13.006-.585.02-.868-.226-.868-.813q0-6.87,0-13.74a.694.694,0,0,1,.749-.8c.832-.015,1.665-.012,2.5,0,.641.006.808.392.8.972-.015,2.254-.005,4.507-.005,6.76"
                                fill="#b0bccb"
                              />
                              <path
                                id="Path_1841"
                                data-name="Path 1841"
                                d="M114.029,83.816c-.014-2.164-.117-1.95,1.921-1.952.465,0,.929.009,1.394,0a.635.635,0,0,1,.725.717q.01,1.282,0,2.567c-.006.552-.323.778-.851.774-.758-.006-1.516-.01-2.274,0-.646.01-.949-.282-.918-.935.019-.391,0-.783,0-1.174"
                                fill="#b0bccb"
                              />
                              <path
                                id="Path_1842"
                                data-name="Path 1842"
                                d="M21.245,60.553a33.987,33.987,0,0,0,.566,6.187l5.087.426a.822.822,0,0,1,.721.607,28.185,28.185,0,0,0,2.941,7.092.818.818,0,0,1-.082.939l-3.294,3.9a33.732,33.732,0,0,0,8.746,8.749l3.9-3.295a.823.823,0,0,1,.942-.081,28.175,28.175,0,0,0,7.091,2.94.822.822,0,0,1,.607.721l.43,5.093a34.41,34.41,0,0,0,12.364,0l.43-5.087a.818.818,0,0,1,.606-.724,28.167,28.167,0,0,0,7.092-2.94.818.818,0,0,1,.939.081l3.9,3.292a33.651,33.651,0,0,0,8.743-8.743l-3.294-3.9a.813.813,0,0,1-.079-.939,28.316,28.316,0,0,0,2.941-7.095.815.815,0,0,1,.721-.607l5.087-.426a33.986,33.986,0,0,0,.565-6.187q0-1.575-.144-3.136a.816.816,0,0,1-.013-.12c-.093-.982-.229-1.961-.408-2.924l-5.087-.43a.812.812,0,0,1-.721-.6,28.116,28.116,0,0,0-2.941-7.1.811.811,0,0,1,.079-.938l3.294-3.9a33.617,33.617,0,0,0-8.743-8.746l-3.9,3.3a.814.814,0,0,1-.939.079,28.076,28.076,0,0,0-3.006-1.526c-.019-.009-.038-.014-.057-.025a28.03,28.03,0,0,0-4.029-1.39.811.811,0,0,1-.606-.721l-.43-5.087a34.41,34.41,0,0,0-12.364,0l-.43,5.09a.815.815,0,0,1-.607.721,28.141,28.141,0,0,0-7.091,2.941.819.819,0,0,1-.939-.079l-3.9-3.3a33.674,33.674,0,0,0-8.746,8.746l3.294,3.9a.816.816,0,0,1,.082.938,28.205,28.205,0,0,0-2.941,7.1.818.818,0,0,1-.721.6l-5.087.43a33.927,33.927,0,0,0-.566,6.18m16.7,0A17.137,17.137,0,1,1,55.081,77.692,17.155,17.155,0,0,1,37.943,60.556"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1843"
                                data-name="Path 1843"
                                d="M21.245,60.553a33.987,33.987,0,0,0,.566,6.187l5.087.426a.822.822,0,0,1,.721.607,28.185,28.185,0,0,0,2.941,7.092.818.818,0,0,1-.082.939l-3.294,3.9a33.732,33.732,0,0,0,8.746,8.749l3.9-3.295a.823.823,0,0,1,.942-.081,28.175,28.175,0,0,0,7.091,2.94.822.822,0,0,1,.607.721l.43,5.093a34.41,34.41,0,0,0,12.364,0l.43-5.087a.818.818,0,0,1,.606-.724,28.167,28.167,0,0,0,7.092-2.94.818.818,0,0,1,.939.081l3.9,3.292a33.651,33.651,0,0,0,8.743-8.743l-3.294-3.9a.813.813,0,0,1-.079-.939,28.316,28.316,0,0,0,2.941-7.095.815.815,0,0,1,.721-.607l5.087-.426a33.986,33.986,0,0,0,.565-6.187q0-1.575-.144-3.136a.816.816,0,0,1-.013-.12c-.093-.982-.229-1.961-.408-2.924l-5.087-.43a.812.812,0,0,1-.721-.6,28.116,28.116,0,0,0-2.941-7.1.811.811,0,0,1,.079-.938l3.294-3.9a33.617,33.617,0,0,0-8.743-8.746l-3.9,3.3a.814.814,0,0,1-.939.079,28.076,28.076,0,0,0-3.006-1.526c-.019-.009-.038-.014-.057-.025a28.03,28.03,0,0,0-4.029-1.39.811.811,0,0,1-.606-.721l-.43-5.087a34.41,34.41,0,0,0-12.364,0l-.43,5.09a.815.815,0,0,1-.607.721,28.141,28.141,0,0,0-7.091,2.941.819.819,0,0,1-.939-.079l-3.9-3.3a33.674,33.674,0,0,0-8.746,8.746l3.294,3.9a.816.816,0,0,1,.082.938,28.205,28.205,0,0,0-2.941,7.1.818.818,0,0,1-.721.6l-5.087.43A33.927,33.927,0,0,0,21.245,60.553Zm16.7,0A17.137,17.137,0,1,1,55.081,77.692,17.155,17.155,0,0,1,37.943,60.556Z"
                                fill="none"
                                stroke="#afbbcb"
                                strokeMiterlimit="10"
                                strokeWidth="2.616"
                              />
                              <path
                                id="Path_1844"
                                data-name="Path 1844"
                                d="M86.647,46.276q-.318-.812-.686-1.6A14.542,14.542,0,0,0,85.63,15.59c-7.938,0-15.448,5.95-15.573,13.861a3.826,3.826,0,0,0-.575-.229q-1.278-.494-2.6-.865l-.432-5.133a.816.816,0,0,0-.648-.732c-.968-.2-1.953-.356-2.946-.468a23.907,23.907,0,0,1,1.891-4.075.811.811,0,0,0-.079-.938l-2.761-3.265a28.794,28.794,0,0,1,7.328-7.329l3.268,2.759a.816.816,0,0,0,.938.082,24,24,0,0,1,6.037-2.5.813.813,0,0,0,.606-.721l.362-4.263a29.235,29.235,0,0,1,10.362,0l.359,4.263a.812.812,0,0,0,.607.721,24.012,24.012,0,0,1,6.036,2.5.818.818,0,0,0,.939-.082l3.267-2.759a28.628,28.628,0,0,1,7.326,7.329l-2.761,3.265a.814.814,0,0,0-.079.941,23.873,23.873,0,0,1,2.5,6.036.819.819,0,0,0,.721.607l4.266.362a29.265,29.265,0,0,1,0,10.359l-4.266.359a.819.819,0,0,0-.721.607,23.873,23.873,0,0,1-2.5,6.036.814.814,0,0,0,.079.941l2.761,3.268a28.676,28.676,0,0,1-7.324,7.323l-3.269-2.759a.818.818,0,0,0-.939-.081,23.652,23.652,0,0,1-3.923,1.841c-.111-.914-.261-1.82-.443-2.715a.819.819,0,0,0-.732-.65l-5.133-.432a28.5,28.5,0,0,0-.936-2.778"
                                fill="#e4e9ef"
                              />
                              <path
                                id="Path_1845"
                                data-name="Path 1845"
                                d="M86.647,46.276q-.318-.812-.686-1.6A14.542,14.542,0,0,0,85.63,15.59c-7.938,0-15.448,5.95-15.573,13.861a3.826,3.826,0,0,0-.575-.229q-1.278-.494-2.6-.865l-.432-5.133a.816.816,0,0,0-.648-.732c-.968-.2-1.953-.356-2.946-.468a23.907,23.907,0,0,1,1.891-4.075.811.811,0,0,0-.079-.938l-2.761-3.265a28.794,28.794,0,0,1,7.328-7.329l3.268,2.759a.816.816,0,0,0,.938.082,24,24,0,0,1,6.037-2.5.813.813,0,0,0,.606-.721l.362-4.263a29.235,29.235,0,0,1,10.362,0l.359,4.263a.812.812,0,0,0,.607.721,24.012,24.012,0,0,1,6.036,2.5.818.818,0,0,0,.939-.082l3.267-2.759a28.628,28.628,0,0,1,7.326,7.329l-2.761,3.265a.814.814,0,0,0-.079.941,23.873,23.873,0,0,1,2.5,6.036.819.819,0,0,0,.721.607l4.266.362a29.265,29.265,0,0,1,0,10.359l-4.266.359a.819.819,0,0,0-.721.607,23.873,23.873,0,0,1-2.5,6.036.814.814,0,0,0,.079.941l2.761,3.268a28.676,28.676,0,0,1-7.324,7.323l-3.269-2.759a.818.818,0,0,0-.939-.081,23.652,23.652,0,0,1-3.923,1.841c-.111-.914-.261-1.82-.443-2.715a.819.819,0,0,0-.732-.65l-5.133-.432A28.5,28.5,0,0,0,86.647,46.276Z"
                                fill="none"
                                stroke="#afbbcb"
                                strokeMiterlimit="10"
                                strokeWidth="2.616"
                              />
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                    <br />
                    <br />
                    <div
                      className="page-title"
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <h1>{t('maintenanceMessage')}</h1>
                    </div>
                    {/*   <div>
                      <p>{t('maintenanceMessageDetails')}</p>
                    </div> */}
                  </div>
                </Container>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
